import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { OpportunitiesTableProps } from '../OpportunitiesTable/OpportunitiesTable.types'

import { OpportunityVisibility } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'
import { LocaleKey } from '@percent/partner-dashboard/i18n/config'

type VisibilityOption = {
  label: string
  value: OpportunityVisibility
  text: LocaleKey
}

const opportunityVisibilityOptions: VisibilityOption[] = [
  {
    label: 'Listed',
    value: OpportunityVisibility.LISTED,
    text: 'status.visibility.listed'
  },
  {
    label: 'Unlisted',
    value: OpportunityVisibility.UNLISTED,
    text: 'status.visibility.unlisted'
  }
]

export const useVisibilityFilter = ({
  queryParams,
  setQueryParams
}: Pick<OpportunitiesTableProps, 'queryParams' | 'setQueryParams'>) => {
  const { t } = useTranslation()

  const onVisibilityChange = useCallback(
    (selectedLabels: string[]) => {
      const selectedValues = selectedLabels
        .map(label => {
          const option = opportunityVisibilityOptions.find(opt => opt.label === label)

          return option?.value
        })
        .filter(Boolean) as OpportunityVisibility[]

      setQueryParams({
        visibility: selectedValues.length ? selectedValues : undefined
      })
    },
    [setQueryParams]
  )

  const getSelectedLabels = (selectedValues: OpportunityVisibility[] | undefined) => {
    if (!selectedValues) return []

    return opportunityVisibilityOptions
      .filter(option => selectedValues.includes(option.value))
      .map(option => option.label)
  }

  return {
    visibilityOptions: opportunityVisibilityOptions.map(opt => ({
      label: t(opt.text),
      value: opt.label
    })),
    onVisibilityChange,
    selectedVisibility: getSelectedLabels(queryParams?.visibility as OpportunityVisibility[] | undefined)
  }
}
